import { stormwaterAnomalies } from './stormwater.js';
import { RECOMMENDATION_ORIGIN_PLACEHOLDER, } from './vocabulary.js';
/**
 * Les travaux que GHP DIGIT écrivait d'office **hors de l'écran Anomalies** (`03_anomalies.md`
 * § 2.4 et RG-F02 à RG-F05), fautes corrigées. Les deux lignes de la remarque « EU mélangées aux
 * EP » n'en font qu'une : la seconde ne se lit pas seule, et le rapport numérote chaque ligne.
 */
const STORMWATER_TO_WASTEWATER_WORKS = 'Séparer les EP des EU, les envoyer vers le milieu naturel ou les raccorder au réseau EP';
const STORMWATER_UNDETERMINED_WORKS = [
    'NOTA : La destination des EP ne préjuge pas de la conformité de celles-ci.',
    'Le propriétaire reste responsable de mener des investigations complémentaires afin de confirmer leur destination.',
];
/** « Décompression » n'écrivait rien. */
const INSTALLATION_REMARK_WORKS = {
    wastewater_through_septic_tank: 'Raccorder les WC en direct, nettoyer la fosse et la condamner',
    macerating_toilet: 'Établir une demande d’autorisation d’un WC broyeur auprès de la mairie',
    wastewater_mixed_with_stormwater: 'Il vous sera obligatoirement demandé l’établissement d’un réseau distinct eaux usées, eaux pluviales, lors du dépôt du permis de construire, de la division parcellaire ou de la mise en séparatif du réseau public',
};
/** Les listes du référentiel où chaque champ d'une anomalie lit son code. */
const LISTS_OF_FIELD = {
    origin: ['fixture', 'origin'],
    provenance: ['provenance'],
    evacuation: ['evacuation'],
    destination: ['destination'],
    technical: ['technical'],
};
/**
 * **Ce que « Travaux à réaliser » propose** (#315, #345), une phrase par ligne, sans doublon : les
 * travaux que le référentiel attache aux valeurs de chaque anomalie (M17), ceux des remarques sur
 * les installations, la séparation des eaux de pluie, puis le NOTA des EP indéterminées.
 *
 * ⚠️ **Une proposition, jamais une réécriture** : l'agent la modifie ou la retire, et sa saisie
 * l'emporte dès lors — c'est le défaut B16 de GHP DIGIT, qui écrasait ses corrections à la
 * réouverture. La séparation des eaux de pluie suit {@link stormwaterAnomalies} : une case « Réseau
 * EU », une case « Réseau unitaire » que le client tient pour une anomalie ou une dérogation.
 *
 * Une situation que le client tient pour conforme ou sans objet (#413) ne propose rien.
 */
export function suggestRecommendations(inspection, vocabulary = []) {
    const { anomalies, survey } = inspection;
    const entryOf = (field, code) => code == null
        ? undefined
        : vocabulary.find((entry) => entry.code === code &&
            LISTS_OF_FIELD[field].includes(entry.list));
    const anomalyWorks = anomalies
        .filter((anomaly) => anomaly.effect !== 'accepted' && anomaly.effect !== 'not_applicable')
        .flatMap((anomaly) => {
        const origin = (entryOf('origin', anomaly.origin)?.label ??
            anomaly.origin ??
            '').toLocaleUpperCase('fr-FR');
        return Object.keys(LISTS_OF_FIELD).flatMap((field) => (entryOf(field, anomaly[field])?.recommendation ?? '')
            .replaceAll(RECOMMENDATION_ORIGIN_PLACEHOLDER, origin)
            .split('\n'));
    });
    const lines = [
        ...anomalyWorks,
        ...(survey.installationRemarks ?? []).map((code) => INSTALLATION_REMARK_WORKS[code] ?? ''),
        ...(stormwaterAnomalies(survey).length > 0 ? [STORMWATER_TO_WASTEWATER_WORKS] : []),
        ...(survey.stormwaterUndetermined === true ? STORMWATER_UNDETERMINED_WORKS : []),
    ]
        .map((line) => line.trim())
        .filter((line) => line !== '');
    return [...new Set(lines)].join('\n');
}
//# sourceMappingURL=recommendations.js.map